module.exports = __webpack_public_path__ + "img/checkbox-checked-svgrepo-com.661c88db.svg";